export default __webpack_public_path__ + "static/media/icn_escrow2.2408f198.svg";